import { deleteRequest, BASE_URL } from '../client'; // 위에서 만든 apiClient.js 파일 가져오기

export async function deleteDailylookComment(
  dailylookId, commentId
  // 객체 디스트럭처링 및 기본값 할당을 사용하여 매개변수 처리
) {

  // 1. API 요청에 필요한 모든 쿼리 파라미터를 담는 객체 생성 (Dart의 payloadObj)
  // 2. PaginatedGet 함수를 await로 호출하여 비동기 결과를 기다림
  // Dart의 BaseClient().PaginatedGet 호출 방식과 유사하게 인자를 전달합니다.
  try {
    const responseBody = await deleteRequest(
      BASE_URL, 
      `/v1/dailylooks/${dailylookId}/comments/${commentId}`, 
      // extraQueryParams 인자로 payloadObj 전달
    );
      
    // API 응답 데이터(GetDailyLook 타입에 해당하는 객체)를 반환
    return responseBody; 

    
  } catch (error) {
    // PaginatedGet 내부에서 발생한 에러를 상위로 전파
    console.error("해시태그 포스트 조회 실패:", error);
    throw error; 
  }
}



